<template>
    <div v-text-align.center>
        <v-spinner />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { enter } from '../../services/api/account';

    export default {
        name: 'sign-profile-partner',
        methods: {
            ...mapActions(['error']),
        },
        mounted() {
            enter(this.$route.query, true)
                .then((res) => {
                    this.$router.push('/');
                })
                .catch((res) => {
                    this.error(res);
                });
        }
    }
</script>


// WEBPACK FOOTER //
// ForceLoginFromPartner.vue?25df0572